// extracted by mini-css-extract-plugin
module.exports = {"profileTable":"PersonalDataTable_profileTable__2mxpG"};